export default function($log) {
  'ngInject';

  const vm = this;

  vm.$onChanges = activate;

  vm.toggle = () => {
    vm.model = !vm.model;
    vm.update({ model: vm.model });
  };

  function activate() {
    $log.debug('Toggle Component Activated');
    vm.model = vm.model || false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/toggle/controller.js